document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-offer__form').forEach((wrapper) => {
    const form = wrapper.querySelector('form[action*="/cart/add"]');
    const addToCartButton = wrapper.querySelector('[data-add-to-cart]');
    const variantInput = wrapper.querySelector('[name="id"]');
    const subscriptionCheckbox = wrapper.querySelector('#offer-subscription');
    const status = wrapper.querySelector('.product-offer__action-status');

    if (!form || !addToCartButton || !variantInput) return;

    function selectedPayload() {
      const selectedCard = wrapper.querySelector('.product-offer__variant-item.selected');
      const sellingPlanId = selectedCard?.dataset.sellingPlanId;
      const payload = {
        id: Number(variantInput.value),
        quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
      };

      if (subscriptionCheckbox?.checked && sellingPlanId) {
        payload.selling_plan = Number(sellingPlanId);
      }

      return payload;
    }

    addToCartButton.addEventListener('click', async () => {
      status.textContent = '';
      addToCartButton.classList.add('loading');
      addToCartButton.disabled = true;
      addToCartButton.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(selectedPayload()),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add this item to the cart.');
        }

        window.location.assign('/cart');
      } catch (error) {
        status.textContent = error.message || 'Unable to add this item. Please try again.';
        addToCartButton.classList.remove('loading');
        addToCartButton.disabled = false;
        addToCartButton.removeAttribute('aria-busy');
      }
    });
  });
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-add-to-cart]').forEach((button) => {
    button.classList.remove('loading');
    button.disabled = false;
    button.removeAttribute('aria-busy');
  });
});
